/* eslint-disable no-console */
import axios from 'axios';

import {API_BASE_URL, API_ENDPOINT_JSON} from '../../../config';
import useUserStore from '../../../store/userStore/userStore';
// import {APIType, APITypeEnum} from '../../interface/tableAPIType';
// import {tableAPIMethod, getRouteIP} from '../../utils/tableAPIMethod';

const OCRAPI = async (
  facility: string = '',
  year: string = ''
): Promise<any> => {
  const token = useUserStore.getState().userToken;

  try {
    const response = await axios.request({
      method: 'GET',
      url: `${API_BASE_URL}${API_ENDPOINT_JSON.OCR}/${facility}/${year}`,
      headers: {
        Authorization: `Bearer ${token}`
      },
      params: {}
    });

    return response.data.data;
  } catch (err) {
    console.log('err:', err);
  }
};

export default OCRAPI;
